import { connect } from 'react-redux';

import type { HeaderCopyBlockProps } from 'src/components/organisms/HeaderCopyBlock/HeaderCopyBlock';
import { HeaderCopyBlock } from 'src/components/organisms/HeaderCopyBlock/HeaderCopyBlock';
import { LinkCarouselTrackingLinkSource } from 'src/components/organisms/LinkCarousel';
import { selectLandedOnPageOne } from 'src/components/organisms/ProductPages/modules/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

const mapStateToProps = (
  state: ReduxApplicationState,
  { internalLinks }: { internalLinks?: { text: string; href: string }[] },
): HeaderCopyBlockProps => {
  const hasInternalLinks = internalLinks ? internalLinks.length > 0 : false;
  return {
    description: selectLandedOnPageOne(state) ? state.products.category!.description : undefined,
    heading: state.products.category!.heading,
    subheading: state.products.category!.subheading,
    links: hasInternalLinks
      ? internalLinks!
      : state.products.navigation[0]?.options.map((categoryLink) => {
          return {
            href: categoryLink.rel!,
            text: categoryLink.title!,
          };
        }) || [],
    trackingLinkDataSource: hasInternalLinks
      ? LinkCarouselTrackingLinkSource.SimilarAI
      : LinkCarouselTrackingLinkSource.Browse,
  };
};

export const HeaderCopyBlockContainer = connect(mapStateToProps)(HeaderCopyBlock);
